export default "__VITE_ASSET__8UnYAkr8__"